import api from '@/api/api_email'
import Vue from 'vue'
import { asyncLoading } from 'vuejs-loading-plugin'
import VueLoading from 'vuejs-loading-plugin'


Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Carregando', // default 'Loading'
    loading: false, // default false
    background: 'rgba(10,23,55,0.7)', // set custom background
})

export default {
  BUSCARPLACAEMAIL ({ commit }, {codUsuario, cidade, placa}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.buscarPlacaEmail(codUsuario, cidade, placa)
        commit("BUSCARPLACAEMAIL", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  CADASTRAREMAIL ({ commit }, {usuario, cidade, email}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.cadastrarEmail(usuario, cidade, email)
        commit("CADASTRAREMAIL", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  ALTERAREMAIL ({ commit }, {codOcorrencia, usuario, cidade, email}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.alterarEmail(codOcorrencia, usuario, cidade, email)
        commit("ALTERAREMAIL", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  DELETAREMAIL ({ commit }, {codigoUsuario, cidade, codigoEmail}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.deletarEmail(codigoUsuario, cidade, codigoEmail)
        commit("DELETAREMAIL", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
  BUSCAREMAILS ({ commit }, {codigoUsuario, cidade}) {
    let loading = new Promise(async (resolve, reject) =>{
      try {
        const info = await api.buscarEmails(codigoUsuario, cidade)
        commit("BUSCAREMAILS", info)
        resolve(info)
      } catch (error) {
        reject(error)
      }
    })
    return asyncLoading(Promise.resolve(loading)).then().catch()
  },
}